import { LicenseReportFormType } from "../../../models";
import { LicenseesUtils } from "../../../utils";
import { NotFoundPage } from "../../shared/error/NotFoundPage";
import { LicenseReportPageAudioVisual } from "./LicenseReportPageAudioVisual";
import { LicenseReportPageEvents } from "./LicenseReportPageEvents";
import { LicenseReportPageShows } from "./LicenseReportPageShows";
import { LicenseReportPageWithDataFiles } from "./LicenseReportPageWithDataFiles";

export function LicenseReportDetailsPageRouter() {
  const urlParams = LicenseesUtils.getUrlParams();
  const renderForm = () => {
    if (!urlParams.licenseInvoicePlanId) return;
    switch (urlParams.licenseReportFormType) {
      case LicenseReportFormType.OnAudioVisual:
        return <LicenseReportPageAudioVisual />;
      case LicenseReportFormType.OnShowsShown:
        return <LicenseReportPageShows />;
      case LicenseReportFormType.WithDataFile:
        return <LicenseReportPageWithDataFiles />;
      case LicenseReportFormType.OnEvents:
        return <LicenseReportPageEvents />;
      default:
        return <NotFoundPage />;
    }
  };

  return renderForm();
}
